'use client';
import { Suspense } from 'react';
import SigninForm from '@/components/SigninForm/SigninForm';
import { Animate } from '@/components/shared/Animation/Animate';
import classNames from 'classnames';

export default function SignInPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/70 via-violet-800/60 to-gray-900/90 animate-gradient"></div>
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px] opacity-20"></div>
      </div>

      <div className="relative z-10 w-full max-w-md">
        <Animate animationName="slideUp">
          <Suspense
            fallback={<div className="text-center text-white">Loading...</div>}
          >
            <SigninForm />
          </Suspense>
        </Animate>
      </div>
    </div>
  );
}
